import {CustomFieldFragment} from '../../../../gql/graphql';

export class CustomFieldModel {
  public title: string;
  public value: string;

  constructor(params: CustomFieldModel) {
    this.title = params.title;
    this.value = params.value;
  }

  public static fromCheckoutV1(customField?: CustomFieldFragment | null) {
    if (!customField) {
      return undefined;
    }
    return new CustomFieldModel({
      title: customField.translatedTitle ?? customField.title!,
      value: customField.value as string,
    });
  }
}
